import { TwilioPhoneContext, TwilioPhoneState } from '@/contexts/contexts';
import { useContext } from 'react';

export function useTwilioPhone(): TwilioPhoneState {
  const context = useContext(TwilioPhoneContext);
  if (!context) {
    throw new Error('useTwilioPhone must be used within a TwilioPhoneProvider');
  }
  return context;
}
